<template>
  <section class="page-section">
    <!-- filter -->
    <div class="filter-region no-margin-top">
      <div class="filter-form">
        <el-form
          size="small"
          :inline="true"
          :model="filterForm"
          ref="filterForm"
        >
          <el-form-item label="订单号：" prop="orderNo">
            <el-input
              v-model="filterForm.orderNo"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="下单时间：" prop="time" class="auto-width">
            <el-date-picker
              v-model="filterForm.time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="time-shortcut">
            <el-button
              plain
              @click="getLastFewDays(-7)"
              :class="{ 'is-active': isActiveShortcut(-7) }"
              >近7天</el-button
            >
            <el-button
              plain
              @click="getLastFewDays(-30)"
              :class="{ 'is-active': isActiveShortcut(-30) }"
              >近30天</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="filter-btn">
        <el-button-group class="btn-group">
          <el-button
            plain
            class="btn-reset"
            icon="el-icon-refresh"
            @click="filterFormReset('filterForm')"
          ></el-button>
          <el-button
            type="primary"
            class="btn-search"
            @click="filterFormSubmit('filterForm')"
            :loading="tableLoading"
            >查询</el-button
          >
        </el-button-group>
      </div>
    </div>

    <el-tabs
      class="mt-20"
      v-model="tabName"
      type="card"
      @tab-click="handleTabsChange"
    >
      <el-tab-pane label="全部" name="2"></el-tab-pane>
      <el-tab-pane label="待审核" name="0"></el-tab-pane>
      <el-tab-pane label="审核通过" name="1"></el-tab-pane>
      <el-tab-pane label="审核不通过" name="-1"></el-tab-pane>
    </el-tabs>

    <!-- table -->
    <div class="table-region mt-10" v-loading="tableLoading">
      <!-- 自定义表格 -->
      <div class="custom-table">
        <div class="custom-table-header">
          <el-row :gutter="10">
            <el-col :span="5">
              <div class="table-cell">商品</div>
            </el-col>
            <el-col :span="3">
              <div class="table-cell">买家</div>
            </el-col>
            <el-col :span="10">
              <div class="table-cell">退款原因</div>
            </el-col>
            <el-col :span="3">
              <div class="table-cell">退款金额</div>
            </el-col>
            <el-col :span="3">
              <div class="table-cell text-align-right">操作</div>
            </el-col>
          </el-row>
        </div>

        <div class="custom-table-body">
          <div class="no-data" v-if="tableData.length == 0">暂无数据</div>

          <!-- order item -->
          <div
            class="order-list-item"
            v-for="(item, index) in tableData"
            :key="index"
            v-else
          >
            <div class="item-header">
              <el-row :gutter="10">
                <el-col :span="22">
                  <div class="table-cell">
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <p class="text">订单号：{{ item.orderNo }}</p>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell text-align-right">
                    <el-button
                      type="text"
                      size="small"
                      @click="pageNavigateToOrderOrderDetail(item)"
                      >查看详情</el-button
                    >
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="item-body">
              <el-row :gutter="10">
                <el-col :span="5">
                  <div class="table-cell">
                    <el-row
                      :gutter="10"
                      v-for="(scope, index) in item.itemList"
                      :key="index"
                    >
                      <el-col>
                        <div class="table-cell">
                          <div class="img-wrap">
                            <div class="img-box">
                              <img :src="scope.picUrl" />
                            </div>
                            <span class="text">{{ scope.name }}</span>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="table-cell">
                    <p class="text">{{ item.buyName }}</p>
                  </div>
                </el-col>
                <el-col :span="10">
                  <div class="table-cell">
                    <p class="text">{{ item.refundReason }}</p>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="table-cell">
                    <p class="text">￥{{ item.refundPrice }}</p>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="table-cell text-align-right">
                    <el-popover
                      placement="top"
                      width="160"
                      v-model="item.passVisible"
                      popper-class="confirm-popover"
                      v-if="item.refundStatus == 0"
                    >
                      <p>确定通过审核？</p>
                      <div>
                        <el-button
                          size="small"
                          type="default"
                          plain
                          @click="item.passVisible = false"
                          >取消</el-button
                        >
                        <el-button
                          size="small"
                          type="primary"
                          @click="pass(item)"
                          >确定</el-button
                        >
                      </div>

                      <span slot="reference"
                        ><el-button size="small" type="text"
                          >通过</el-button
                        ></span
                      >
                    </el-popover>
                    &nbsp;
                    <el-popover
                      placement="top"
                      width="160"
                      v-model="item.failVisible"
                      popper-class="confirm-popover"
                      v-if="item.refundStatus == 0"
                    >
                      <p>确定不通过审核？</p>
                      <div>
                        <el-button
                          size="small"
                          type="default"
                          plain
                          @click="item.failVisible = false"
                          >取消</el-button
                        >
                        <el-button
                          size="small"
                          type="primary"
                          @click="fail(item)"
                          >确定</el-button
                        >
                      </div>

                      <span slot="reference"
                        ><el-button size="small" type="text"
                          >不通过</el-button
                        ></span
                      >
                    </el-popover>
                    <p v-if="item.refundStatus == 1" style="opacity: 0.7">
                      通过
                    </p>
                    <p v-if="item.refundStatus == -1" style="opacity: 0.7">
                      不通过
                    </p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-footer" v-if="page.total > 0">
      <div class="selection-operate"></div>

      <div class="pagination-wrap">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[20, 50, 100]"
          :pager-count="5"
          :current-page="page.current"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import {
  financialDepositList,
  financialDepositCheck,
  COMMON,
} from "../../../common/api";

export default {
  name: "goodsManageList",
  data() {
    return {
      tabName: "2", // 选项卡name 审核状态类型

      filterForm: {
        // 筛选表单值
        orderNo: "", // 订单号
        time: "", // 下单时间起止点
      },

      page: {
        // 分页参数
        current: 1,
        size: 20,
        total: 0,
      },

      tableLoading: true,
      tableData: [], // 表格数据
    };
  },
  methods: {
    /**
     * [getList description] 获取表格数据
     * @return {[type]} [description]
     */
    getList: function () {
      this.tableLoading = true;

      let param = {
        status: Number(this.tabName),
        orderNo: this.filterForm.orderNo,
        startDate: this.filterForm.time ? this.filterForm.time[0] : "",
        endDate: this.filterForm.time ? this.filterForm.time[1] : "",
        current: this.page.current,
        size: this.page.size,
      };

      financialDepositList(param)
        .then((res) => {
          this.tableLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.tableData = data.records || [];
            this.page.total = data.total;
            this.$nextTick(() => {
              const scrollContainer = document.querySelector(".app-container");
              if (scrollContainer) {
                scrollContainer.scrollTop = 0;
              }
            });
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.tableLoading = false;
          this.$message.error("服务器异常");
        });
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择表格第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    /**
     * [handleTabsChange description] 切换选项卡
     * @param  {[type]} tab   [description] 取name值用tab.name
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */
    handleTabsChange: function (tab, event) {
      // this.filterFormReset('filterForm');
      this.page.current = 1;
      this.page.size = 20;
      this.getList();
    },
    /**
     * [filterFormSubmit description] 提交筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormSubmit: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getList();
        } else {
          return false;
        }
      });
    },
    /**
     * [filterFormReset description] 重置筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * [pageNavigateToOrderOrderDetail description] 查看订单详情
     * @param  {[Object]} item [description] 当前操作的订单对象
     * @return {[type]}          [description]
     */
    pageNavigateToOrderOrderDetail: function (item) {
      this.$router.push({
        path: "/order/order/detail",
        query: { id: item.id },
      });
    },
    /**
     * [pass description] 通过审核
     * @param  {[Object]} item [description] 操作的对象
     * @return {[type]}          [description]
     */
    pass: function (item) {
      item.passVisible = false;

      let param = {
        id: item.id,
        refundStatus: 1,
      };

      this.check(param);
    },
    /**
     * [fail description] 不通过审核
     * @param  {[Object]} item [description] 操作的对象
     * @return {[type]}          [description]
     */
    fail: function (item) {
      item.failVisible = false;

      let param = {
        id: item.id,
        refundStatus: -1,
      };

      this.check(param);
    },
    /**
     * [check description] 审核
     * @param  {[Object]} param [description] 参数
     * @return {[type]}          [description]
     */
    check: function (param) {
      financialDepositCheck(param)
        .then((res) => {
          let { code, data, msg } = res;

          if (code == 0) {
            this.$message.success("操作成功");
            this.getList();
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.tableLoading = false;
          this.$message.error("服务器异常");
        });
    },
    /**
     * [isActiveShortcut description] 判断快捷时间是否选中
     * @param  {[Number]} day [description] 近几日
     * @return {[Boolean]}     [description]
     */
    isActiveShortcut(day) {
      if (!this.filterForm.time || this.filterForm.time.length !== 2)
        return false;
      const start = COMMON.getDay(day);
      const end = COMMON.getDay(0);
      return (
        this.filterForm.time[0] === start && this.filterForm.time[1] === end
      );
    },
    /**
     * [getLastFewDays description] 获取近几日日期
     * @param  {[Number]} day [description] 需要获取的近几日的数值
     * @return {[type]}        [description]
     */
    getLastFewDays: function (day) {
      this.filterForm.time = [];
      this.filterForm.time.push(COMMON.getDay(day));
      this.filterForm.time.push(COMMON.getDay(0));
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";

.mr-10 {
  margin-right: 10px;
}

.mt-20 {
  margin-top: 20px;
}

.mt-10 {
  margin-top: 10px !important;
}

// .page-container {
//   height: 100%;
// }

// .page-main {
//   flex: 1;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column;
// }

// .page-section {
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   overflow: hidden;

::v-deep .el-tabs {
  flex-shrink: 0; // 选项卡区域不压缩
}

// }

.filter-region {
  // flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;

  .filter-form {
    flex: 1;

    .el-form-item {
      &.time-shortcut {
        background: initial;
        padding: 0;

        :deep(.el-form-item__content) {
          width: auto;

          .el-button {
            width: 110px;
            height: 40px;
            border-radius: 5px;

            &.is-active {
              border: 1px solid #3388ff;
              color: #3388ff;
              background-color: #ecf5ff;
            }
          }
        }
      }
    }
  }

  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        & + .el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }
}

.table-region {
  // flex: 1; // 占用剩余高度
  // display: flex;
  // flex-direction: column;
  // overflow: hidden;
  margin-bottom: 50px;

  .custom-table {
    // flex: 1;
    // display: flex;
    // flex-direction: column;
    // overflow: hidden;

    .custom-table-header {
      // flex-shrink: 0;
      padding-right: 4px;
      text-align: center;
      scrollbar-gutter: stable;
    }

    // .custom-table-body {
    //   flex: 1;
    //   overflow-y: auto;
    //   overflow-x: hidden;
    //   padding-right: 5px; // 避免滚动条遮挡内容
    // }
  }

  // .table-footer {
  //   flex-shrink: 0;
  // }
}
</style>
